import React, { useEffect, useState } from "react";
import http from "../lib/http";

export default function DealerLeadsPage() {

  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const [statusFilter, setStatusFilter] = useState("all");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const dealer =  JSON.parse(localStorage.getItem("dealer"));

  const fetchLeads = async () => {
    try {

      setLoading(true);

      const res = await http.get("/api/dealers/leads", {
        params: {
          dealerId: dealer._id,
          page,
          status: statusFilter
        }
      });

      setLeads(res.data.leads || []);
      setTotalPages(res.data.totalPages || 1);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, [page, statusFilter]);

  const updateStatus = async (leadId, status) => {
    try {

      await http.patch(`/api/dealer/leads/${leadId}/status`, {
        status
      });

      fetchLeads();

    } catch (err) {
      console.error(err);
    }
  };

  const getBadgeColor = (status) => {

    switch (status?.toLowerCase()) {

      case "new":
        return "primary";

      case "contacted":
        return "warning";

      case "closed":
        return "success";

      default:
        return "secondary";
    }
  };

  if (loading) {
    return (
      <div className="container py-5 text-center">
        Loading customer leads...
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">

      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">

        <div>
          <h2 className="fw-bold mb-0">Customer Leads</h2>
          <small className="text-muted">
            Manage customer enquiries
          </small>
        </div>

        <div className="mt-2 mt-md-0">
          <select
            className="form-select"
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value="all">All Leads</option>
            <option value="new">New</option>
            <option value="contacted">Contacted</option>
            <option value="closed">Closed</option>
          </select>
        </div>

      </div>

      {/* MOBILE VIEW */}

      <div className="d-block d-lg-none">

        {leads.map((lead) => (

          <div
            className="card shadow-sm border-0 mb-3"
            key={lead._id}
          >
            <div className="card-body">

              <div className="d-flex justify-content-between">
                <h5>{lead.customerName}</h5>

                <span className={`badge bg-${getBadgeColor(lead.status)}`}>
                  {lead.status}
                </span>
              </div>

              <p className="mb-1">
                📞 {lead.customerPhone}
              </p>

              <p className="mb-1">
                📅 {new Date(
                  lead.enquiryDate || lead.createdAt
                ).toLocaleDateString()}
              </p>

              <p className="text-muted small">
                {lead.enquiryMessage || "No message"}
              </p>

              <div className="mt-3">

                {lead.status === "New" && (
                  <button
                    className="btn btn-warning btn-sm me-2"
                    onClick={() =>
                      updateStatus(
                        lead._id,
                        "Contacted"
                      )
                    }
                  >
                    Contacted
                  </button>
                )}

                {lead.status !== "Closed" && (
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() =>
                      updateStatus(
                        lead._id,
                        "Closed"
                      )
                    }
                  >
                    Close
                  </button>
                )}

              </div>

            </div>
          </div>

        ))}

      </div>

      {/* DESKTOP TABLE */}

      <div className="table-responsive d-none d-lg-block">

        <table className="table table-hover align-middle">

          <thead className="table-light">

            <tr>
              <th>Customer</th>
              <th>Phone</th>
              <th>Date</th>
              <th>Message</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>

          </thead>

          <tbody>

            {leads.map((lead) => (

              <tr key={lead._id}>

                <td>{lead.customerName}</td>

                <td>
                  <a href={`tel:${lead.customerPhone}`}>
                    {lead.customerPhone}
                  </a>
                </td>

                <td>
                  {new Date(
                    lead.enquiryDate || lead.createdAt
                  ).toLocaleDateString()}
                </td>

                <td>
                  {lead.enquiryMessage || "-"}
                </td>

                <td>
                  <span
                    className={`badge bg-${getBadgeColor(
                      lead.status
                    )}`}
                  >
                    {lead.status}
                  </span>
                </td>

                <td>

                  {lead.status === "New" && (
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={() =>
                        updateStatus(
                          lead._id,
                          "Contacted"
                        )
                      }
                    >
                      Contacted
                    </button>
                  )}

                  {lead.status !== "Closed" && (
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() =>
                        updateStatus(
                          lead._id,
                          "Closed"
                        )
                      }
                    >
                      Close
                    </button>
                  )}

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

      {totalPages > 1 && (

        <nav className="mt-4">

          <ul className="pagination justify-content-center">

            {Array.from(
              { length: totalPages },
              (_, i) => i + 1
            ).map((p) => (

              <li
                key={p}
                className={`page-item ${
                  p === page ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setPage(p)}
                >
                  {p}
                </button>
              </li>

            ))}

          </ul>

        </nav>

      )}

    </div>
  );
}